import Api from 'libs/api/index';

class ExperienceYearsApi extends Api {
  constructor() {
    super('cv/experience_years/');
  }
}

export default ExperienceYearsApi;
